import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { isResponsiveProp } from "@faire/web--source/slate/Theme/ResponsiveProp";
import React from "react";
export var LoggedOutHomeImage = function(param) {
    var responsiveImage = param.responsiveImage, optimizeImageOptions = param.optimizeImageOptions, className = param.className, altText = param.altText, lazyLoad = param.lazyLoad, imageStyles = param.imageStyles;
    var imageOptionsMobile = isResponsiveProp(optimizeImageOptions) ? optimizeImageOptions.mobileAndAbove : optimizeImageOptions;
    var imageOptionsTablet = isResponsiveProp(optimizeImageOptions) ? optimizeImageOptions.tabletAndAbove : optimizeImageOptions;
    var imageOptionsDesktop = isResponsiveProp(optimizeImageOptions) ? optimizeImageOptions.desktopAndAbove : optimizeImageOptions;
    var imageOptionsXLarge = isResponsiveProp(optimizeImageOptions) ? optimizeImageOptions.xLargeAndAbove : optimizeImageOptions;
    var imageOptionsXXLarge = isResponsiveProp(optimizeImageOptions) ? optimizeImageOptions.xxLargeDesktop : optimizeImageOptions;
    var isSSR = useIsSSR();
    var imageMobile = responsiveImage.mobileAndAbove;
    var imageTablet = responsiveImage.tabletAndAbove;
    var imageDesktop = responsiveImage.desktopAndAbove;
    var imageXLarge = responsiveImage.xLargeAndAbove;
    var imageXXLarge = responsiveImage.xxLargeDesktop;
    if (!imageMobile && !imageTablet && !imageDesktop && !imageXLarge && !imageXXLarge) {
        return null;
    }
    var imageUrlMobile = getOptimizedImageUrl(imageMobile, imageOptionsMobile, isSSR);
    var imageUrlTablet = imageOptionsTablet || imageTablet ? getOptimizedImageUrl(imageTablet !== null && imageTablet !== void 0 ? imageTablet : imageMobile, imageOptionsTablet !== null && imageOptionsTablet !== void 0 ? imageOptionsTablet : imageOptionsMobile, isSSR) : undefined;
    var _ref, _ref1;
    var imageUrlDesktop = imageOptionsDesktop || imageDesktop ? getOptimizedImageUrl((_ref = imageDesktop !== null && imageDesktop !== void 0 ? imageDesktop : imageTablet) !== null && _ref !== void 0 ? _ref : imageMobile, (_ref1 = imageOptionsDesktop !== null && imageOptionsDesktop !== void 0 ? imageOptionsDesktop : imageOptionsTablet) !== null && _ref1 !== void 0 ? _ref1 : imageOptionsMobile, isSSR) : undefined;
    var _ref2, _ref3, _ref4, _ref5;
    var imageUrlXLarge = imageOptionsXLarge || imageXLarge ? getOptimizedImageUrl((_ref3 = (_ref2 = imageXLarge !== null && imageXLarge !== void 0 ? imageXLarge : imageDesktop) !== null && _ref2 !== void 0 ? _ref2 : imageTablet) !== null && _ref3 !== void 0 ? _ref3 : imageMobile, (_ref5 = (_ref4 = imageOptionsXLarge !== null && imageOptionsXLarge !== void 0 ? imageOptionsXLarge : imageOptionsDesktop) !== null && _ref4 !== void 0 ? _ref4 : imageOptionsTablet) !== null && _ref5 !== void 0 ? _ref5 : imageOptionsMobile, isSSR) : undefined;
    var _ref6, _ref7, _ref8, _ref9, _ref10, _ref11;
    var imageUrlXXLarge = imageOptionsXXLarge || imageXXLarge ? getOptimizedImageUrl((_ref8 = (_ref7 = (_ref6 = imageXXLarge !== null && imageXXLarge !== void 0 ? imageXXLarge : imageXLarge) !== null && _ref6 !== void 0 ? _ref6 : imageDesktop) !== null && _ref7 !== void 0 ? _ref7 : imageTablet) !== null && _ref8 !== void 0 ? _ref8 : imageMobile, (_ref11 = (_ref10 = (_ref9 = imageOptionsXXLarge !== null && imageOptionsXXLarge !== void 0 ? imageOptionsXXLarge : imageOptionsXLarge) !== null && _ref9 !== void 0 ? _ref9 : imageOptionsDesktop) !== null && _ref10 !== void 0 ? _ref10 : imageOptionsTablet) !== null && _ref11 !== void 0 ? _ref11 : imageOptionsMobile, isSSR) : undefined;
    return /*#__PURE__*/ _jsxs("picture", {
        className: className,
        children: [
            imageUrlXXLarge ? /*#__PURE__*/ _jsx("source", {
                media: "(min-width: 1728px)",
                srcSet: imageUrlXXLarge
            }) : null,
            imageUrlXLarge ? /*#__PURE__*/ _jsx("source", {
                media: "(min-width: ".concat(MIN_WIDTH_BREAKPOINTS.XLARGE, "px)"),
                srcSet: imageUrlXLarge
            }) : null,
            imageUrlDesktop ? /*#__PURE__*/ _jsx("source", {
                media: "(min-width: ".concat(MIN_WIDTH_BREAKPOINTS.DESKTOP, "px)"),
                srcSet: imageUrlDesktop
            }) : null,
            imageUrlTablet ? /*#__PURE__*/ _jsx("source", {
                media: "(min-width: ".concat(MIN_WIDTH_BREAKPOINTS.TABLET, "px)"),
                srcSet: imageUrlTablet
            }) : null,
            /*#__PURE__*/ _jsx("img", {
                style: _object_spread({
                    objectFit: "cover",
                    width: "100%",
                    height: "100%"
                }, imageStyles),
                src: imageUrlMobile !== null && imageUrlMobile !== void 0 ? imageUrlMobile : EAEAEA_PIXEL,
                alt: altText !== null && altText !== void 0 ? altText : imageMobile.alt_text,
                loading: lazyLoad ? "lazy" : undefined,
                width: "100%",
                height: "100%"
            })
        ]
    });
};
var getOptimizedImageUrl = function(image, optimizeImageOptions, isSSR) {
    return optimizeImageUrl({
        url: image.url
    }, isSSR, optimizeImageOptions);
};
